import * as ko from "knockout"
import {FormValidator} from "./FormValidator";
import {IPasswordPolicy} from "../../../index";
import {PASSWORD_MINIMUM_LOWERCASE_LETTERS} from "../../../constants";
import {PASSWORD_NO_LANGUAGE_SPECIFIC_LETTERS_KEY} from "./hasOnlyAsciiLetters";
import suggestionsHtml from './suggestions.html?raw';

export const template: string = suggestionsHtml;

interface IParams {
    observableInputs: IObservableInputs
    passwordpolicy: IPasswordPolicy
    formValidator: FormValidator
}

interface ICriteria {
    isValid: KnockoutComputed<boolean>
    label: string
    key?: string
    isRelevant: boolean
}

export class viewModel {
    private criterias: ICriteria[]

    constructor(params: IParams) {
        this.criterias = [
            {
                isValid: params.formValidator.isWithinLength,
                label: 'password.length between|min:' + params.passwordpolicy.minimumlength + '|max:' + params.passwordpolicy.maximumlength,
                key: 'is-within-length',
                isRelevant: !!params.passwordpolicy.minimumlength || !!params.passwordpolicy.maximumlength,
            },
            {
                isValid: params.formValidator.isLowerCase,
                label: 'password.at least one lowercase letter|min:' + PASSWORD_MINIMUM_LOWERCASE_LETTERS,
                key: 'is-lower-case',
                isRelevant: true,
            },
            {
                isValid: params.formValidator.isUpperCase,
                label: 'password.minimum upper case letter|num:' + params.passwordpolicy.nrupper,
                key: 'is-upper-case',
                isRelevant: !!params.passwordpolicy.nrupper,
            },
            {
                isValid: params.formValidator.isNumbers,
                label: 'password.minimum digit|num:' + params.passwordpolicy.nrnumeral,
                key: 'is-numbers',
                isRelevant: !!params.passwordpolicy.nrnumeral,
            },
            {
                isValid: params.formValidator.isSpecial,
                label: 'password.minimum special character|num:' + params.passwordpolicy.nrspecial,
                key: 'is-special',
                isRelevant: !!params.passwordpolicy.nrspecial,
            },
            {
                isValid: params.formValidator.hasOnlyAsciiLetters,
                label: PASSWORD_NO_LANGUAGE_SPECIFIC_LETTERS_KEY,
                key: 'has-only-ascii-letters',
                isRelevant: true,
            },
        ]
    }
}
